import { useQuery } from '@tanstack/react-query';
import { tuitionBandApi } from '@/features/reports/api/tuitionBand.api';
import { groupComparisonsFilterQueryKeys } from '@/features/reports/hooks/useGroupComparisonsSchoolBandsQuery';

/** GET /api/app/tuition-band?Year=… */
export function useGroupComparisonsTuitionBandsQuery(year: string | undefined) {
  const y = year?.trim() ?? '';
  const yearNum = Number(y);
  const enabled = y !== '' && Number.isFinite(yearNum);

  return useQuery({
    queryKey: groupComparisonsFilterQueryKeys.tuitionBands(y),
    queryFn: () =>
      tuitionBandApi.getList({
        year: yearNum,
        skipCount: 0,
        maxResultCount: 500,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
